<template>
  <div class="radioTitle">
    <span v-html="content"></span>
  </div>
  <el-radio-group
    v-model="selectedOption"
    @change="onChange"
    class="stool-radio-group"
  >
    <el-radio
      v-for="option in options"
      :key="option.value"
      :label="option.value"
      border
      class="stool-radio"
      :disabled="this.disabled"
    >
      <div class="radio-card">
        <img :src="option.image" class="stool-image" />
        <div class="stool-text">
          <strong>{{ option.title }}</strong>
          <p>{{ option.label }}</p>
        </div>
      </div>
    </el-radio>
  </el-radio-group>
</template>

<script>
export default {
  name: "QuestionnaireRadio",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
    },
    content: {
      type: String,
      required: true,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    mobileWidth: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      default: "",
    },
    requiredMessage: {
      type: String,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.selectedOption = newValue;
      },
    },
  },
  emits: ["onChange"],
  data() {
    return {
      selectedOption: this.value,
      radioHeight: this.height === "tall" ? "80px" : "42px",
      radioWidth: this.width === "wide" ? "27vw" : this.width,
    };
  },
  methods: {
    onChange() {
      this.$emit("onChange", this.selectedOption);
    },
  },
};
</script>

<style scoped>
.radioTitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.175px;
  margin-bottom: 12px;
  white-space: pre-line;
}

.stool-radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
}

.stool-radio {
  --el-radio-border-radius: 12px;
  --el-radio-border-color: #ccc;
  padding: 0;
  width: 100%;
}

.radio-card {
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stool-image {
  height: 50px;
  width: auto;
  margin-bottom: 8px;
}

.stool-text p {
  margin: 4px 0 0;
  font-size: 14px;
  height: 30px;
  width: 200px;
}

.stool-text strong {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.175px;
  padding: 3px 8px;
  background-color: #f2b344;
  color: #000;
}

.el-radio-group {
  display: flex;
  padding: 0px;
  box-sizing: border-box;
  flex-wrap: wrap;
  row-gap: 24px;
  column-gap: 0px;
  align-items: flex-start;
  justify-content: center;
}

:deep(.el-radio.is-bordered) {
  width: v-bind("radioWidth");
  min-height: v-bind("radioHeight");
  height: fit-content;
  border-radius: 4px;
  border: none;
  margin-right: 0px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column-reverse;
}


:deep(.el-radio__label) {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.46px;
  color: #000000;
  white-space: normal;
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #000000;
}

:deep(.el-radio__input.is-disabled + span.el-radio__label) {
  color: #000000;
}

:deep(.el-radio__inner) {
  height: 20px !important;
  width: 20px !important;
  border: 2px #000000 solid;
  margin-left: 5px;
  margin-right: 5px;
}

:deep(.el-radio__input.is-disabled .el-radio__inner) {
  border: 2px #bcccdc solid;
  background: transparent !important;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border: 2px #20a8c3 solid !important;
  background: transparent !important;
}

:deep(.el-radio__input.is-checked .el-radio__inner::after) {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #20a8c3;
  border-radius: 50%;
  box-sizing: border-box;
  border: 2px #20a8c3 solid !important;
}

@media only screen and (max-width: 808px) {
  .el-radio-group {
    gap: 8px;
  }
  :deep(.el-radio.is-bordered) {
    min-height: 42px;
    height: fit-content;
    width: v-bind("mobileWidth");
  }

  .radioTitle {
    font-size: 14px;
  }

  :deep(.el-radio__label) {
    font-size: 14px;
  }

  .stool-image {
    height: 42px;
  }

  .stool-text strong {
    font-size: 14px;
  }

  .el-radio div {
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  :deep(.el-radio__inner) {
    height: 16px !important;
    width: 16px !important;
    margin-left: 8px;
    margin-right: 8px;
    border: 1px #000000 solid !important;
  }

  :deep(.el-radio__input.is-checked .el-radio__inner::after) {
    width: 8px;
    height: 8px;
    border: 1px #20a8c3 solid !important;
  }
}
</style>
